@if (profileField$ | async; as profileField) {
  <sh-form-edtf
    [id]="profileField.FieldDefinition.FlatKey"
    [control]="control$ | async"
    [label]="profileField.DisplayLabel"
    [labelIcons]="labelIcons"
    [helpText]="profileField.Description"
    [i18n]="typeTranslations"
    [typePlaceholderMsg]="'form.edtf.choose-type' | translate"
    [typeLabel]="profileField.DisplayLabel"
    [valueLabel]="'form.edtf.edtf-value' | translate"
    [formatExamplePrefix]="'form.edtf.example-prefix' | translate"
    [invalidFormatMsg]="'form.edtf.invalid-format' | translate"
    [unrecognizedFormatMsg]="'form.edtf.unrecognized-format' | translate"
    [errorMsg]="(errorMsg$ | async) || '' | translate"
    [canBeIndeterminate]="canBeIndeterminate"
    [indeterminateMsg]="'general.different-values' | translate"
    [title]="disabledMessageKey | translate"
    >
    <ng-content></ng-content
    ></sh-form-edtf>
  }
